var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Service {
  constructor() {
    __publicField(this, "props");
    this.callbacks = /* @__PURE__ */ new Map();
    this.isInit = false;
  }
  updateProps(...args) {
    this.props = args;
    throw new Error("The `updateProps` method must be implemented.");
  }
  init() {
    throw new Error("The `init` method must be implemented.");
  }
  kill() {
    throw new Error("The `kill` method must be implemented.");
  }
  add(key, callback) {
    if (this.has(key)) {
      throw new Error(`A callback with the key \`${key}\` has already been registered.`);
    }
    if (this.callbacks.size === 0 && !this.isInit) {
      this.init();
      this.isInit = true;
    }
    this.callbacks.set(key, callback);
  }
  has(key) {
    return this.callbacks.has(key);
  }
  get(key) {
    return this.callbacks.get(key);
  }
  remove(key) {
    this.callbacks.delete(key);
    if (this.callbacks.size === 0 && this.isInit) {
      this.kill();
      this.isInit = false;
    }
  }
  trigger(...args) {
    this.callbacks.forEach(function forEachCallback(callback) {
      callback(...args);
    });
    return this;
  }
}
export {
  Service as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
